import { SIZE_25 } from '@/lib/gridElements/size';

// kpis
import { avgViewsRatePerVideoConfig } from '@/lib/analytics/kpis/youtube/avgViewsRatePerVideo';
import { totalViewsConfig } from '@/lib/analytics/kpis/youtube/totalViews';
import { avgViewsPerVideoConfig } from '@/lib/analytics/kpis/youtube/avgViewsPerVideo';
import { totalLikesConfig } from '@/lib/analytics/kpis/youtube/totalLikes';
import { avgLikesReceivedConfig } from '@/lib/analytics/kpis/youtube/avgLikesReceived';
import { avgDislikesReceivedConfig } from '@/lib/analytics/kpis/youtube/avgDislikesReceived';
import { totalDislikesConfig } from '@/lib/analytics/kpis/youtube/totalDislikes';
import { totalCommentsConfig } from '@/lib/analytics/kpis/youtube/totalComments';
import { avgCommentsReceivedPerPostConfig } from '@/lib/analytics/kpis/youtube/avgCommentsPerVideo';
import { totalSharesConfig } from '@/lib/analytics/kpis/youtube/totalShares';
import { avgSharesConfig } from '@/lib/analytics/kpis/youtube/avgSharesPerVideo';
import { totalCardImpressionsConfig } from '@/lib/analytics/kpis/youtube/totalCardImpressions';
import { totalCardImpressionPerVideoConfig } from '@/lib/analytics/kpis/youtube/totalCardImpressionPerVideo';

// widgets
import { mostEngagingVideosConfig } from '@/lib/analytics/widget/youtube/mostEngagingVideosConfig';

// charts
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/youtube/videoViewsHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/youtube/likesHistory';
import { dislikesHistoryConfig } from '@/lib/analytics/charts/youtube/dislikesHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/youtube/bestTimeToPost';
import { commentsHistoryConfig } from '@/lib/analytics/charts/youtube/commentsHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/youtube/sharesHistory';

export const EngagementYoutube = [
    // First line
    totalViewsConfig,
    avgViewsRatePerVideoConfig,

    // Second line
    mostEngagingVideosConfig,

    // Third line
    avgViewsPerVideoConfig,
    videoViewsHistoryConfig,

    // Fourth line
    totalLikesConfig,
    avgLikesReceivedConfig,
    totalDislikesConfig,
    avgDislikesReceivedConfig,

    // Fifth line
    likesHistoryConfig,
    dislikesHistoryConfig,

    // Sixth line
    bestTimeToPostConfig,

    // Seventh line
    { ...totalCommentsConfig, size: SIZE_25 },
    avgCommentsReceivedPerPostConfig,
    { ...totalSharesConfig, size: SIZE_25 },
    avgSharesConfig,

    // Eighth line
    commentsHistoryConfig,
    sharesHistoryConfig,

    // Ninth line
    totalCardImpressionsConfig,
    totalCardImpressionPerVideoConfig
];

export const requestYoutubeParams = [
    [
        'engagement',
        'average_engagement_rate_per_video',
        'average_engagement_rate_on_views',
        'average_view_rate_per_video',
        'average_engagement_rate_history',
        'average_engagement_rate_on_views_history',
        'total_views',
        'average_views_per_video',
        'video_views_history',
        'likes',
        'average_likes_per_video',
        'dislikes',
        'average_dislikes_per_video'
    ],
    [
        'likes_history',
        'dislikes_history',
        'best_time_to_post',
        'comments',
        'average_comments_per_video',
        'shares',
        'average_shares_per_video',
        'comments_history',
        'shares_history',
        'card_impressions',
        'card_impressions_per_video'
    ]
];

export const requestYoutubeOtherParameters = {
    best_time_to_post: {
        type: bestTimeToPostConfig.defaultFilter ?? 'views'
    }
};
